import { ListStore } from "_common/list/ListStore";
import { TObjWithId } from "_common/types/GenericTypes";
import { action, computed, observable } from "mobx";

export class AdminListStore<T extends TObjWithId> extends ListStore<T> {
    @observable selectedIds: Set<string> = new Set();

    @computed get selectedItems() {
        return this.paginatedItems.filter((i) => i && this.selectedIds.has(i._id)) as T[];
    }

    @computed get selectedItemsIds() {
        return [...this.selectedIds];
    }

    @computed get allSelected() {
        return this.selectedItems.length === this.paginatedItems.length;
    }

    isSelected(id: string) {
        return this.selectedIds.has(id);
    }

    @action toggleSelection(id: string) {
        if (this.selectedIds.has(id)) this.selectedIds.delete(id);
        else this.selectedIds.add(id);
    }

    @action selectAll() {
        for (const item of this.items) {
            if (item) this.selectedIds.add(item._id);
        }
    }

    @action clearSelection() {
        this.selectedIds.clear();
    }
}
